function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 1,
  y: 1,
  width: 20,
  height: 26,
  rx: 1,
  stroke: "#3C3C3B",
  strokeWidth: 2
});

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  x: 28,
  y: 24,
  width: 21,
  height: 25,
  rx: 1,
  stroke: "#3C3C3B",
  strokeWidth: 2
});

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  x: 1,
  y: 34,
  width: 20,
  height: 15,
  rx: 1,
  stroke: "#9F9A98",
  strokeWidth: 2
});

var _ref5 =
/*#__PURE__*/
React.createElement("rect", {
  x: 28,
  y: 1,
  width: 21,
  height: 16,
  rx: 1,
  stroke: "#9F9A98",
  strokeWidth: 2
});

var SvgFeatureOne5 = function SvgFeatureOne5(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFeatureOne5, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/FeatureOne-5.2c51a01a.svg";
export { ForwardRef as ReactComponent };